import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { SecurityService } from '@shared/services/security.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-table-documents',
  templateUrl: './table-documents.component.html',
  styleUrls: ['./table-documents.component.scss'],
})
export class TableDocumentsComponent implements OnChanges {

  @Input() tableName: string;
  @Input() allDocuments: any[];
  @Input() receipt : boolean;

  @Output() sign: EventEmitter<any> = new EventEmitter();

  documents: any[];

  password: string;
  isVisible = false;

  selectedDocument: any;

  constructor(private securityService: SecurityService) { }

  ngOnChanges(): void {
    this.documents = [];
    this.allDocuments.forEach((document : any) => {
      if (!document.assinado && !document.assinaturaForaPrazo) {
        this.documents.push(document);
      }
    });

  }

  parseButtonName() {
    return this.tableName.slice(0, -1);
  }

  signDocument(data: any) {
    this.selectedDocument = data;
    this.isVisible = true;
  }

  handleModalOk() {
    this.securityService.validatePassword(this.password).subscribe(() => {
      this.sign.emit(this.selectedDocument);
      const idx = this.documents.indexOf(this.selectedDocument);
      if(idx !== -1){
        this.documents.splice(idx, 1);
      }
      this.selectedDocument.assinado = true;
      this.isVisible = false;
      this.password = "";
    });
  }

  handleModalCancel() {
    this.password = null;
    this.selectedDocument = null;
    this.isVisible = false;
  }

  openDocument(data: any) {
    window.open(environment.api + data.url);
  }
}
